import { render } from "./LoginHeader.vue?vue&type=template&id=735cc9a8&scoped=true"
import script from "./LoginHeader.vue?vue&type=script&lang=js"
export * from "./LoginHeader.vue?vue&type=script&lang=js"

import "./LoginHeader.vue?vue&type=style&index=0&id=735cc9a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735cc9a8"]])

export default __exports__